import { combineReducers } from "@reduxjs/toolkit";
import { ChatData } from "./Chat/chatreducer";

export default combineReducers({ ChatData });
